import useClients from './useClients';
import useClientTasks from './useClientTasks';
import useClientCredentials from './useClientCredentials';
import useClientUsers from './useClientUsers';
import useModules from './useUIModules';
import useClientProperties from './useClientProperties';
import useClientGroupUsers from './useClientGroupUsers';

const useClientDetails = (id: string) => {
  const { clients, isLoading: clientsLoading } = useClients();
  const { tasks, isLoading: tasksLoading } = useClientTasks(id);
  const { credentials, isLoading: credLoading } = useClientCredentials(id);
  const { users, isLoading: userLoading } = useClientUsers(id);
  const { uiModules, isLoading: modLoading } = useModules();
  const { properties } = useClientProperties(id);
  const { groupUsers, isLoading: groupUserLoading } = useClientGroupUsers(id);

  return {
    clients,
    tasks,
    credentials,
    users,
    uiModules,
    properties,
    groupUsers,
    isLoading:
      clientsLoading ||
      tasksLoading ||
      credLoading ||
      userLoading ||
      modLoading ||
      groupUserLoading,
  };
};
export default useClientDetails;
